// Generated by BUCKLESCRIPT VERSION 2.0.0, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var Printf      = require("bs-platform/lib/js/printf.js");
var Caml_int32  = require("bs-platform/lib/js/caml_int32.js");
var Pervasives  = require("bs-platform/lib/js/pervasives.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Tile.css')));

var tileSpacing = "1px";

var tileSpacingTransform = "translateX(-1px) translateY(-1px)";

function floatToCssPercent(f) {
  return Curry._1(Printf.sprintf(/* Format */[
                  /* Float */Block.__(8, [
                      /* Float_f */0,
                      /* No_padding */0,
                      /* No_precision */0,
                      /* Char_literal */Block.__(12, [
                          /* "%" */37,
                          /* End_of_format */0
                        ])
                    ]),
                  "%f%%"
                ]), f);
}

var component = ReasonReact.statelessComponent("Tile");

function make(originalPosition, position, gridSize, isVisible, source, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var posX = Caml_int32.imul(Caml_int32.mod_(position, gridSize), 100);
      var posY = Caml_int32.imul(Caml_int32.div(position, gridSize), 100);
      var transform = "translateX(" + Pervasives.string_of_int(posX) + "%) translateY(" + Pervasives.string_of_int(posY) + "%)";
      var width = Pervasives.string_of_float(100 / gridSize) + "%";
      var offsetX = Caml_int32.mod_(originalPosition, gridSize) / gridSize * 100;
      var offsetY = Math.floor(originalPosition / gridSize) / gridSize * 100;
      var imageTransform = "translateX(-" + floatToCssPercent(offsetX) + ") translateY(-" + floatToCssPercent(offsetY) + ") " + tileSpacingTransform;
      return React.createElement("div", {
                  className: "Tile",
                  style: {
                    visibility: isVisible !== 0 ? "visible" : "hidden",
                    width: width,
                    transform: transform
                  }
                }, React.createElement("div", {
                      className: "Tile-content",
                      style: {
                        margin: tileSpacing
                      }
                    }, React.createElement("img", {
                          className: "Tile-source",
                          style: {
                            transform: imageTransform
                          },
                          src: source
                        })));
    });
  return newrecord;
}

exports.tileSpacing          = tileSpacing;
exports.tileSpacingTransform = tileSpacingTransform;
exports.floatToCssPercent    = floatToCssPercent;
exports.component            = component;
exports.make                 = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/Tile.re
// module id = 45
// module chunks = 0